<!-- 资金管理-审批列表 -->
<template>
  <div>
    <page :url="url" :form="form" @reset="reset">
      <template slot="tableSearch">
        <el-form-item :label="$t('text.merchantName')">
          <el-select
              v-model="form.appId"
              filterable
              :placeholder="$t('message.chooseOne')"
              popper-class="eloption"
          >
            <el-option :label="$t('option.all')" value=""></el-option>
            <el-option
                v-for="merchant in merchantList"
                :label="merchant.value + '-' + merchant.name"
                :key="merchant.value"
                :value="merchant.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('text.rechargeStatus')">
          <el-select v-model="form.status" :placeholder="$t('text.status')">
            <el-option :label="$t('option.all')" value=""></el-option>
            <el-option :label="$t('rechargeStatus.00')" value="00"></el-option>
            <el-option :label="$t('rechargeStatus.01')" value="01"></el-option>
            <el-option :label="$t('rechargeStatus.02')" value="02"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('text.orderNumber')">
          <el-input v-model="form.orderId" :placeholder="$t('text.orderNumber')" maxlength="50"></el-input>
        </el-form-item>

        <el-form-item :label="$t('text.date')">
          <el-date-picker
              v-model="timeDate"
              type="daterange"
              format="yyyy-MM-dd"
              value-format="yyyyMMdd"
              :range-separator="$t('text.to')"
              :start-placeholder="$t('text.startDate')"
              :end-placeholder="$t('text.endDate')"
              @change="timeChange"
          >
          </el-date-picker>
        </el-form-item>
      </template>

      <template slot="tableColumn">
        <el-table-column
            width="200"
            prop="orderId"
            :label="$t('text.orderNumber')"
            align="center"
        ></el-table-column>

        <el-table-column
            prop="status"
            :label="$t('text.rechargeStatus')"
            width="80px"
            :formatter="$formatter.formatApprovalStatus"
            align="center"
        >
          <template slot-scope="{ row }">
            <el-tag
                size="small"
                :type="
                row.status === '00'
                  ? 'warning'
                  : row.status === '01'
                  ? 'success'
                  : 'danger'
              "
            >{{
                $formatter.formatApprovalStatus(null, null, row.status, null)
              }}
            </el-tag
            >
          </template>
        </el-table-column>

        <el-table-column
            width="180"
            prop="appId"
            :label="$t('text.appId')"
            align="center"
        ></el-table-column>
        <el-table-column
            width="120"
            prop="merchantName"
            :label="$t('text.merchantName')"
            align="center"
        ></el-table-column>

        <el-table-column
            prop="amount"
            :label="$t('text.rechargeAmount')"
            width="120"
            :formatter="$formatter.FenToYuanToThousandth"
            align="center"
        ></el-table-column>

        <el-table-column
            width="160"
            prop="dealTimeFormat"
            :label="$t('text.processingTime')"
            align="center"
        ></el-table-column>

        <el-table-column
            width="150"
            prop="approveRemark"
            :label="$t('text.approvalRemark')"
            align="center"
        >
          <template slot-scope="{ row }">
            <div v-if="row.approveRemark">
              <el-popover
                  v-if="row.approveRemark && row.approveRemark.length > 10"
                  placement="top-start"
                  width="300"
                  trigger="hover"
                  :content="row.approveRemark"
              >
                <div slot="reference" class="remark">
                  {{ row.approveRemark }}
                </div>
              </el-popover>
              <div v-else>{{ row.approveRemark }}</div>
            </div>
            <div v-else>--</div>
          </template>
        </el-table-column>

        <el-table-column
            width="200"
            prop="paymentAccount"
            :label="$t('text.disbursementAccount')"
            align="center"
        >
          <template slot-scope="{ row }">
            <div v-if="row.paymentAccount">{{ row.paymentAccount }}</div>
            <div v-else>--</div>
          </template>
        </el-table-column>

        <el-table-column
            width="200"
            prop="collectAccount"
            :label="$t('text.collectionAddress')"
            align="center"
        ></el-table-column>

        <el-table-column
            width="160"
            prop="remark"
            :label="$t('text.applicationNote')"
            align="center"
        >
          <template slot-scope="{ row }">
            <div v-if="row.remark">
              <el-popover
                  v-if="row.remark.length > 10"
                  placement="top-start"
                  width="300"
                  trigger="hover"
                  :content="row.remark"
              >
                <div slot="reference" class="remark">{{ row.remark }}</div>
              </el-popover>
              <div v-else>{{ row.remark }}</div>
            </div>
            <div v-else>--</div>
          </template>
        </el-table-column>

        <el-table-column
            width="160"
            prop="createTimeFormat"
            :label="$t('text.creationTime')"
            align="center"
        ></el-table-column>
      </template>
    </page>
    <ApproveRechargeWithdraw :is-show-adopt-dialog.sync="isShowAdoptDialog" :id="id"
                             :rowData="rowData"></ApproveRechargeWithdraw>
    <RejectRechargeWithdraw :is-show-refuse-dialog.sync="isShowRefuseDialog" :id="id"></RejectRechargeWithdraw>
  </div>
</template>
<script>
import Page from "@/components/Page.vue";
import ApproveRechargeWithdraw from "@/views/capital/components/ApproveRechargeWithdraw.vue";
import RejectRechargeWithdraw from "@/views/capital/components/RejectRechargeWithdraw.vue";
import {ROLE_TYPE} from "@/utils/Constant";

export default {
  computed: {
    ROLE_TYPE() {
      return ROLE_TYPE
    }
  },
  components: {
    page: Page,
    ApproveRechargeWithdraw: ApproveRechargeWithdraw,
    RejectRechargeWithdraw: RejectRechargeWithdraw
  },
  props: {
    fromMerchantList: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      url: "/depositWithdraw/selectList?type=00",
      action: "",
      timeDate: [],
      form: {
        appId: "",
        startDate: "",
        endDate: "",
        tradeOrderId: ""
      },
      showDialog: false,
      formData: null,
      totalAmount: "",
      totalFee: "",
      totalActualAmount: "",
      merchantList: [],
      isShowAdoptDialog: false,
      isShowRefuseDialog: false,
      id: "",
      rowData: '',
    };
  },
  methods: {
    timeChange(e) {
      console.log(this.timeDate);
      if (e) {
        this.form.startDate = e[0];
        this.form.endDate = e[1];
      } else {
        this.form.startDate = "";
        this.form.endDate = "";
      }
    },
    reset() {
      this.timeDate = [];
    },
    add() {
      this.action = "addWithdraw";
      this.formData = null;
      this.showDialog = true;
    },
    confirm(row) {
      this.$confirm(this.$t('message.confirmDoingWithdrawal'), this.$t('text.prompt'), {
        confirmButtonText: this.$t('text.confirm'),
        cancelButtonText: this.$t('text.cancel'),
        type: "warning"
      })
          .then(() => {
            this.axios
                .post("/withdraw/confirm", {orderId: row.orderId})
                .then((res) => {
                  if (res.code === 200) {
                    this.$bus.$emit("refresh"); //通知刷新
                    this.$notify({
                      title: this.$t('text.prompt'),
                      message: res.msg,
                      type: "success"
                    });
                  } else {
                    this.$notify.error({
                      title: this.$t('text.prompt'),
                      message: res.msg
                    });
                  }
                });
          })
          .catch(() => {
          });
    },
    exportDetail() {
      this.axios
          .get("/withdraw/exportDetail", {params: this.form})
          .then((res) => {
            if (res.code === 200) {
              window.location.href =
                  "/common/downloadFile?fileId=" + res.data.fileId;
            } else {
              this.$notify.error({
                title: this.$t('text.prompt'),
                message: res.msg
              });
            }
          });
    },
  },
  watch: {
    fromMerchantList() {
      this.merchantList = this.fromMerchantList;
      if (this.merchantList.length === 1) {
        this.form.appId = this.merchantList[0].value;
        this.$bus.$emit("refresh");
      }
    }
  }
};
</script>
<style scoped>

.remark {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}
</style>
